<template>
  <div class="input-form-cell">
  <van-field
      :required="true"
      v-model="value"
      :name="name"
      :label="label"
      :label-width="labelWidth || 140"
      :placeholder="placeholder"
      :formatter="formatter"
      :inputmode="inputModel || 'decimal'"
      @input="onChange"
      :readonly="editor===false"
      :rules="[{ required: true, message: '请填写内容' }]"
  >
    <template #extra>
      <div>{{right || '万'}}</div>
    </template>
  </van-field>
  </div>
</template>

<script>

export default {
  name: "inputFormCell",
  props: ['label', 'name', 'initValue', 'right', 'placeholder', 'labelWidth', 'inputModel', 'formatter', 'editor'],
  data() {
    return {
      value: this.initValue
    }
  },
  watch: {
    initValue(newValue, oldValue) {
      // console.log('input initValue ', newValue, oldValue)
      this.value = newValue
    }
    // initValue: {
    //   handler: (val, olVal) => {
    //     // debugger
    //     this.value = newValue
    //
    //     // this.$nextTick(() => {
    //     //   console.log('handler => this.columns ', this.columns)
    //     //   this.value = this.columns[val]
    //     // })
    //
    //     // debugger
    //   },
    //   immediate: true
    // },
  },
  methods: {
    // numberFormatter(value) {
    //   // 过滤输入的数字
    //   return unit.clearNoNum(value);
    // },
    onChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>
<style lang="less">
.input-form-cell {
  .van-field__label {
    font-size: 13px;
    font-weight: 400;
    color: #3F403F;
  }
  .van-cell {
    padding: 10px 16px 10px 22px !important;
  }
  .van-cell--required::before {
    left: 14px !important;
  }
}
</style>
<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/modules/marketCenter/formCell/inputFormCell.vue